import { observer } from 'mobx-react-lite';

import { Badge } from '@/components/ui/Badge';

import { useSubscription } from './subscription.query';

export const MeetingUsageBadge = observer(() => {
  const subscription = useSubscription();

  const meetingLimits = subscription.status.meeting_limits;
  const meetingsUsed = meetingLimits?.meetings_used;
  const meetingsLimit = meetingLimits?.meetings_limit;
  const meetingsRemaining = meetingLimits?.meetings_remaining;
  const warningThreshold = meetingLimits?.warning_threshold;

  const hasUsageData = meetingsUsed !== undefined;
  const shouldShowBadge =
    hasUsageData &&
    meetingsRemaining !== undefined &&
    warningThreshold !== undefined &&
    meetingsRemaining <= warningThreshold;

  const usageText = hasUsageData
    ? meetingsLimit
      ? `${meetingsUsed}/${meetingsLimit} notes used`
      : `${meetingsUsed} notes`
    : null;

  if (!shouldShowBadge || !usageText) return null;

  return (
    <Badge variant="default" size="xs" className="rounded-full px-2 py-0 h-6">
      {usageText}
    </Badge>
  );
});
